if (!customElements.get('mgp-service-carousel')) {
  customElements.define('mgp-service-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mgp-footer-services__grid');
      this.items = [...this.querySelectorAll('.mgp-footer-services__item')];
      this.buttons = [...this.querySelectorAll('.mgp-footer-services__dot')];
      this.controls = this.querySelector('.mgp-footer-services__controls');
      if (!this.track || !this.items.length) return;
      this.abort = new AbortController();
      this.mobile = matchMedia('(max-width: 640px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      const options = { signal: this.abort.signal };
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.select(index), options));
      this.addEventListener('keydown', event => {
        if (!this.mobile.matches) return;
        let index = this.index;
        if (event.key === 'ArrowRight') index++;
        else if (event.key === 'ArrowLeft') index--;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.items.length - 1;
        else return;
        event.preventDefault();
        index = Math.max(0, Math.min(this.items.length - 1, index));
        if (event.target.matches('button')) this.buttons[index].focus({ preventScroll: true });
        this.select(index);
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateCurrent());
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => {
        this.track.tabIndex = this.mobile.matches ? 0 : -1;
        this.track.scrollTo({ left: this.mobile.matches ? this.items[this.index].offsetLeft - this.items[0].offsetLeft : 0, behavior: 'instant' });
      });
      this.resize.observe(this.track);
      if (this.controls) this.controls.hidden = this.items.length < 2;
      this.dataset.ready = 'true';
      this.updateCurrent();
    }
    select(index) {
      this.index = index;
      this.track.scrollTo({ left: this.items[index].offsetLeft - this.items[0].offsetLeft, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
    }
    updateCurrent() {
      if (this.mobile.matches) {
        let best = Infinity;
        this.items.forEach((item, index) => {
          const distance = Math.abs(item.offsetLeft - this.items[0].offsetLeft - this.track.scrollLeft);
          if (distance < best) { best = distance; this.index = index; }
        });
      }
      this.buttons.forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resize?.disconnect();
      this.abort?.abort();
    }
  });
}
